import { render, staticRenderFns } from "./DSMessages.vue?vue&type=template&id=5a783846&"
import script from "./DSMessages.vue?vue&type=script&lang=js&"
export * from "./DSMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports